import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Layout from '../../components/Layout';
import { usePageTracking } from '../../hooks/usePageTracking';
import useRedeemCards from '../../hooks/useRedeemCards';
import { getImagesStaticUrl } from '../../utils/helpers';
import RedeemForm from './RedeemForm';
import RedemptionTable from './RedemptionTable';
import Title from './Title';
import * as styles from './giftCardRedemption.module.scss';

const REDEMPTION_CODE_PARAM = 'redemption_code';

const GiftCardRedemption = () => {
  const [codeInput, setCodeInput] = useState('');
  const [hasErrorMessage, setHasErrorMessage] = useState('');
  const [customerMessage, setCustomerMessage] = useState('');
  const { giftCards, handleRedeemCard } = useRedeemCards();
  const queryString = useLocation().search;
  const redemptionCode = new URLSearchParams(queryString).get(REDEMPTION_CODE_PARAM);

  usePageTracking();

  useEffect(() => {
    if (redemptionCode) {
      setCodeInput(redemptionCode);
    }
  }, [redemptionCode]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setCustomerMessage('');
    setHasErrorMessage('');
    if (codeInput) {
      handleRedeemCard(codeInput)
        .then((result) => {
          setCustomerMessage(result.message);
        })
        .catch((error) => {
          setHasErrorMessage(error.customer_message);
        });
    }
  };

  return (
    <Layout
      pageTitle="Redeem Gift Credit - FabFitFun"
      redirectIfNoAuth
      meta={{
        links: [{ href: 'https://fonts.googleapis.com/css2?family=Montserrat&display=swap' }],
      }}
    >
      <div className={styles.siteContent}>
        <div className={styles.rowFull}>
          <article className={styles.page}>
            <div className={styles.fffGiftCreditContainer}>
              <div
                className={styles.giftCreditContent}
                style={{
                  background: `url(${getImagesStaticUrl('redeem-giftcard-background.jpeg')})`,
                }}
              >
                <div className={styles.container}>
                  <Title />
                  <div className={styles.giftCreditFormContainer}>
                    <div id="recurly_form">
                      <div className={styles.row}>
                        <div className={`${styles.giftFormWrap} ${styles.giftCreditFormBlock}`}>
                          <div>
                            <RedeemForm
                              handleSubmit={handleSubmit}
                              setInput={setCodeInput}
                              inputValue={codeInput}
                              customerMessage={customerMessage}
                              errorMessage={hasErrorMessage}
                            />
                            <RedemptionTable giftCards={giftCards} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </Layout>
  );
};

export default GiftCardRedemption;
